export enum SERVER_USER_STORAGE_IDENTIFIER {
  NDB_LANDING_COUPON = 'ndb-landing-coupon',
}

export const SWR_USER_STORAGE_ITEMS_KEY = '/user_storage_items';
